import React, {Component} from 'react';
import AuthService from "../services/auth.service";
import Menu from '../Components/Menu';
import axios from 'axios';
import './Portal.css';
import { Modal,ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import Salaryslip from '../Popup/Salaryslip';
import Leavebalance from '../Components/Leavebalance';
import moment from 'moment'
import Leaveapplication from '../Popup/Leaveapplication';
import Leavehistory from '../Components/Leavehistory';
class  Portal extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            username: "",
            password: "",
            loading:false,
            id:[],
            date:[],
            menu:[],
            docs:[],
            earn:[],
            modal: false,
            modal2: false
          };
    }
    async componentDidMount(){
       
        AuthService.getCurrentUser();
        const user = AuthService.getCurrentUser();
        const USR_TOKEN = localStorage.getItem("userToken")
        this.setState({ id:user })
            if(!user){
                this.setState({ loading:false });
                window.location.href = "/";
            }  
            else{
                this.setState({ loading:true });
                axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Salary Slip?fields=["posting_date","name"]&order_by=posting_date desc'), {
                    headers : {'Authorization' : USR_TOKEN, 
                'content-type': 'application/json'}
                })
                .then(response=>{
                        this.setState({date:response.data.data})
                        //console.log(response.data)

                })
                .catch(err=>{
                    //window.location.href = "/";
                    //this.setState({name:response.data['data'][0]})
                    //console.log("done")
                })
            } 
    }
    modalOpen(id) {
        //alert(id)
        const USR_TOKEN = localStorage.getItem("userToken")
        this.setState({ modal: true });
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Salary Slip/'+id), {
            headers : {'Authorization' : USR_TOKEN, 
        'content-type': 'application/json'}
        })
        .then(response=>{
                this.setState({docs:response.data.data})
                //this.setState({earn:response.data.data.earnings})
                //console.log(response.data.data.earnings)

        })
        .catch(err=>{
            //window.location.href = "/";
            //this.setState({name:response.data['data'][0]})
            //console.log("done")
        })
      }

      modal2Open(id) {
        //alert(id)
        const USR_TOKEN = localStorage.getItem("userToken")
        this.setState({ modal2: true });
      }
  render() {
      
        return this.state.loading ? 
                <div className="nk-content ">
                    <div className="container wide-xl">
                        <div className="nk-content-inner">
                            {/* <div className="nk-aside" data-content="sideNav" data-toggle-overlay="true" data-toggle-screen="lg" data-toggle-body="true">
                                <Menu/>
                                <div className="nk-aside-close">
                                <a href="#" className="toggle" data-target="sideNav"><em className="icon ni ni-cross"></em></a>
                                </div>
                            </div> */}{/* <!-- .nk-aside --> */}
                            <div className="nk-content-body">
                                <div className="nk-content-wrap">
                                <button className="float-right leave-btn" onClick={e => this.modal2Open()}> Leave Application</button>
                                    <div className="nk-block-head wide-md nk-block-head-lg">
                                    {/*  <div className="nk-block-head-sub"><span>Supports</span></div> */}
                                        <div className="nk-block-head-content">
                                            <h2 className="nk-block-title fw-normal">Welcome, {this.state.id.full_name}</h2>
                                            
                                            <p>Welcome to hrportal.</p>
                                            
                                            {/* <div className="nk-search-box">
                                                <div className="form-group">
                                                    <div className="form-control-wrap">
                                                        <input type="text" className="form-control form-control-lg" placeholder="Search..."/>
                                                        <button className="form-icon form-icon-right">
                                                            <em className="icon ni ni-search"></em>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div> */}
                                            {/* <div className="nk-block-des">
                                            <ul className="list-inline">
                                                <li><a href="html/subscription/index.html">Home</a></li>
                                                <li><a href="html/subscription/tickets.html">Tickets</a></li>
                                                <li><a href="#">Terms & Policy</a></li>
                                                </ul>
                                            </div>  */}
                                        </div>
                                    </div>{/* <!-- .nk-block-head --> */}
                                    <div className="row g-gs ">
                                        <div className="col-md-4">
                                        <h5 className="mb-3">Salary Slip</h5>
                                            <div className=" card-bordered card float-left w-75 ">
                                                <a className="support-topic-block p-2 h-100" /* href={'/'+itm.internal} */ >
                                                    <div className="support-topic-context">
                                                        {/* <h6 className="support-topic-title title text-center">Salary Slip</h6> */}
                                                        <ul className="">
                                                        { this.state.date.map((item,k)=>{
                                                            if(k<6){
                                                            return(
                                                                <li key={k} className="">
                                                                    <div className="col-10 float-left p-1"><p><strong>{moment(item.posting_date).format('DD MMMM YYYY')}</strong></p></div>
                                                                    <div className="col-2 float-left p-1">  <a href="#" type="button" onClick={e => this.modalOpen(item.name)}><i className="fa fa-eye ml-3"></i></a></div>
                                                                </li>
                                                            )
                                                            }
                                                            else 
                                                            return ""
                                                        })}
                                                        </ul>
                                                    </div>
                                                </a> 
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <Leavebalance/>
                                       </div>
                                       {/* <div className="col-md-12">
                                            <Leavehistory/>
                                       </div> */}
                                                
                                    </div>

                                    <Modal size="xl" toggle={() => this.setState({ modal: false })} isOpen={this.state.modal} show={this.state.modal}>
                                        <a
                                            href="#cancel"
                                            onClick={() => this.setState({ modal: false })}
                                            className="close"
                                        >
                                        <i className="fa fa-close"></i>
                                        </a>
                                            <ModalBody className="mt-5">
                                                
                                                <Salaryslip docData={this.state.docs} close={this.state.modal}/>
                                            </ModalBody>
                          
                                    </Modal>


                                    <Modal size="xl" toggle={() => this.setState({ modal2: false })} isOpen={this.state.modal2} show={this.state.modal2}>
                                        <a
                                            href="#cancel"
                                            onClick={() => this.setState({ modal2: false })}
                                            className="close"
                                        >
                                        <i className="fa fa-close"></i>
                                        </a>
                                            <ModalBody className="mt-5">
                                                
                                                <Leaveapplication/>
                                            </ModalBody>
                          
                                    </Modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>:""
}
}
export default Portal;